import { PriceInformation } from "./types";

const topLevelDomainMap: Record<string, string> = {
  AE: "ae",
  AU: "com.au",
  BE: "com.be",
  CA: "ca",
  DE: "de",
  ES: "es",
  FR: "fr",
  IT: "it",
  JP: "co.jp",
  MX: "com.mx",
  NL: "nl",
  PL: "pl",
  SA: "sa",
  SE: "se",
  SG: "sg",
  UK: "co.uk",
};

export const getTotalCost = (priceInfo: PriceInformation | undefined) => {
  return (
    (priceInfo?.productCost ?? 0) +
    (priceInfo?.shippingCost ?? 0) +
    (priceInfo?.warehouseCost ?? 0)
  ).toFixed(2);
};

export const getDomainByCountryCode = (code: string): string => {
  return topLevelDomainMap[code] ?? "com";
};
